/**
 * Asks the updates bell to open with one announcement unfolded (HAT-1489) - «לפרטים» in a bubble.
 * A window event rather than shared state: the bell sits in the header and the bubble in Layout, and
 * neither should have to know where the other is mounted.
 */
export const OPEN_ANNOUNCEMENT_EVENT = 'announcements:open';

export interface OpenAnnouncementDetail {
  id: number;
}

/**
 * A button in an announcement may say `{fund}` where a fund id belongs - the seed is written once for
 * every fund. Filled with the fund on screen, or else the reader's first fund; a link that needs a
 * fund and has none to take is dropped rather than sent somewhere wrong.
 */
export const resolveAnnouncementUrl = (url: string, fundId: string | number | null | undefined): string | null => {
  if (!url.includes('{fund}')) return url;
  if (fundId === null || fundId === undefined || fundId === '') return null;
  return url.split('{fund}').join(String(fundId));
};
